const carouselItems = [
  {
    title: '《奔跑吧》第十二季',
    desc: '全新阵容热血回归，王牌MC再度集结，开启新一轮户外竞技挑战。经典撕名牌环节升级回归，更有神秘飞行嘉宾惊喜空降。',
    tag: '户外竞技',
    img: 'https://readdy.ai/api/search-image?query=An%20outdoor%20team%20game%20show%20scene%20with%20colorful%20obstacles%20and%20energetic%20atmosphere%2C%20bright%20sunlight%2C%20large%20inflatable%20props%2C%20running%20track%20style%20course%2C%20dynamic%20action%20composition%2C%20vibrant%20warm%20colors%2C%20entertainment%20TV%20production%20quality%2C%20no%20visible%20faces%2C%20silhouettes%20of%20people%20in%20motion&width=800&height=500&seq=carousel-01-51movies&orientation=landscape',
  },
  {
    title: '《乘风2024》',
    desc: '姐姐们再度集结舞台，实力唱将与跨界艺人同台竞演，谁能突破重围斩获年度成团席位？',
    tag: '音乐竞演',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20music%20competition%20show%20stage%20with%20golden%20and%20coral%20red%20spotlights%2C%20elegant%20stage%20design%20with%20LED%20floor%20screens%2C%20theatrical%20fog%20effects%2C%20grand%20performance%20atmosphere%2C%20professional%20concert%20lighting%2C%20warm%20amber%20tones%2C%20no%20visible%20people%2C%20silhouette%20of%20a%20performer%20on%20stage&width=800&height=500&seq=carousel-02-51movies&orientation=landscape',
  },
  {
    title: '《王牌对王牌》第八季',
    desc: '经典游戏爆笑全场，沈腾贾玲再度同台飙戏。全新企划环节脑洞大开，每一期都是笑点密集的快乐源泉。',
    tag: '喜剧综艺',
    img: 'https://readdy.ai/api/search-image?query=A%20colorful%20comedy%20talk%20show%20TV%20studio%20set%20with%20bright%20warm%20lighting%2C%20comfortable%20colorful%20sofa%20arrangement%2C%20playful%20game%20props%20scattered%20around%2C%20festive%20studio%20decoration%2C%20entertainment%20variety%20show%20atmosphere%2C%20vibrant%20orange%20and%20yellow%20tones%2C%20no%20visible%20people&width=800&height=500&seq=carousel-03-51movies&orientation=landscape',
  },
  {
    title: '《这就是街舞7》',
    desc: '全球顶尖舞者巅峰对决，四位明星队长各带战队激烈角逐。炸裂齐舞、神仙Battle，每一帧都是视觉盛宴。',
    tag: '舞蹈竞技',
    img: 'https://readdy.ai/api/search-image?query=An%20urban%20street%20dance%20competition%20stage%20with%20dynamic%20neon%20accent%20lighting%20in%20warm%20orange%20and%20amber%20tones%2C%20industrial%20warehouse%20style%20venue%2C%20graffiti%20wall%20background%2C%20dramatic%20spotlights%2C%20energetic%20atmosphere%2C%20professional%20dance%20show%20production%2C%20no%20visible%20people%2C%20motion%20blur%20effects&width=800&height=500&seq=carousel-04-51movies&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
              焦点专题
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              本季必看综艺精选
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              精选当前最受关注的综艺节目，一网打尽不容错过的精彩内容
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all group cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}